import * as CRMObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
export default {
  [CRMObjectTypes.CONTACT_ID]: 'contacts',
  [CRMObjectTypes.DEAL_ID]: 'deals',
  [CRMObjectTypes.TICKET_ID]: 'ticket',
  [CRMObjectTypes.COMPANY_ID]: 'companies',
  [CRMObjectTypes.QUOTE_ID]: 'enroll',
  [CRMObjectTypes.CALL_ID]: 'calling'
};
export const DEFAULT_ICON = 'customObject';